// src/app/shell/shell.component.ts
import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BreakpointObserver } from '@angular/cdk/layout';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import { TopNavComponent } from './top-nav/top-nav.component';
import { AppSidebarComponent } from './sidebar/app-sidebar.component';

@Component({
  selector: 'app-shell',
  standalone: true,
  imports: [RouterOutlet, MatSidenavModule, TopNavComponent, AppSidebarComponent],
  template: `
    <div class="flex flex-col h-screen">
      <app-top-nav (toggleSidebar)="onToggleSidebar()" />
      <mat-sidenav-container class="flex-1">
        <mat-sidenav
          [mode]="isMobile() ? 'over' : 'side'"
          [opened]="isMobile() ? sidebarOpen() : true"
          (openedChange)="sidebarOpen.set($event)"
          style="width: 240px; border-right: 1px solid hsl(var(--sidebar-border));">
          <app-sidebar />
        </mat-sidenav>
        <mat-sidenav-content style="background: hsl(var(--background));">
          <div class="p-6">
            <router-outlet />
          </div>
        </mat-sidenav-content>
      </mat-sidenav-container>
    </div>
  `,
})
export class ShellComponent {
  readonly sidebarOpen = signal(false);
  private readonly bp = inject(BreakpointObserver);
  readonly isMobile = toSignal(
    this.bp.observe('(max-width: 1024px)').pipe(map(r => r.matches)),
    { initialValue: false }
  );

  onToggleSidebar(): void {
    this.sidebarOpen.update(v => !v);
  }
}
